import { useState } from "react";
import { useProductTranslations } from "../../hooks/TranslationHooks";
import { Button, Modal, ModalBody } from "reactstrap";
import { modalZIndex } from "../../utils/UiUtils";
import Icon from "../Icon";

const CareInstructionModal = ({ content }) => {
  const tp = useProductTranslations();
  const [show, setShow] = useState(false);
  if (!content) {
    return null;
  }
  const toggle = () => setShow(!show);
  const __html = content.instruction;
  return (
    <>
      <h4 style={{ cursor: "pointer" }} onClick={toggle}>
        {tp("care_instruction") + " "}
        <Icon name="circle-question" />
      </h4>
      <Modal
        isOpen={show}
        toggle={toggle}
        size={"lg"}
        backdrop={true}
        zIndex={modalZIndex()}
      >
        <ModalBody>
          <Button close={true} onClick={toggle}>
            <Icon name="xmark" type="fal" />
          </Button>
          <div
            dangerouslySetInnerHTML={{
              __html
            }}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default CareInstructionModal;
